import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { rgba } from '@savgroup-front-common/primitive/helpers/cssColor';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $RowContainer = styled(Row)`
  flex-direction: column;
  align-items: center;
  margin-left: unset;
  margin-right: unset;
  h2 {
    text-align: center;
    font-weight: ${fontWeight('bold')};
    @media ${media.maxWidth.sm} {
      ${fontStyle('xl')};
    }
  }
  & > * {
    margin-top: ${spacing('xxl')};
  }
`;

export const $SubtitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  background-color: ${({ theme }) => rgba(theme.colors.success, 0.1)};
  padding: ${spacing('lg')};
  span {
    color: ${({ theme }) => theme.colors.success};
    ${fontStyle('base')};
    font-weight: 700;
  }
  svg {
    margin-right: ${spacing('lg')};
  }
`;

export const $RowButtonContainer = styled(Row)`
  width: 100%;
  justify-content: space-between;
  @media ${media.maxWidth.sm} {
    flex-direction: column-reverse;
  }
`;
